import { render, staticRenderFns } from "./HRPostItem.vue?vue&type=template&id=3710a488&scoped=true&"
import script from "./HRPostItem.vue?vue&type=script&lang=js&"
export * from "./HRPostItem.vue?vue&type=script&lang=js&"
import style0 from "./HRPostItem.vue?vue&type=style&index=0&id=3710a488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710a488",
  null
  
)

export default component.exports